import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SEOFriendlyEcommerceWebsitesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="SEO-friendly E-commerce Websites in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Rank Higher, Sell More</Subheading>}
        heading={
          <Heading>
            SEO-friendly <span tw="text-primary-500">E-commerce Websites</span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset builds SEO-friendly e-commerce websites in **Al
            Barsha**, optimizing your online store for search engines to drive
            traffic, visibility, and sales.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1661956602944-249bcd04b63f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1523289333742-be1143f6b766?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Boost Your Rankings"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why SEO Matters</Subheading>}
        heading="Optimized for Success"
        description="Our SEO-friendly websites maximize your online reach."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Higher Rankings",
            description: "Dominate search engine results.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Increased Traffic",
            description: "Attract more store visitors.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Technical SEO",
            description: "Fast, crawlable websites.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimization",
            description: "SEO-ready for all devices.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Structure",
            description: "Trusted by search engines.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Experts",
            description: "Local SEO specialists.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Optimize</Subheading>}
        heading="Our SEO-friendly E-commerce Development Process"
        description={
          <Description>
            We build stores that rank and convert:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Analyze keywords and competitors.</li>
              <li>Design: Create SEO-optimized layouts.</li>
              <li>Development: Build with fast, clean code.</li>
              <li>Optimization: Implement meta tags and schema.</li>
              <li>Launch: Deploy a search-ready store.</li>
              <li>Support: Monitor and improve rankings.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="SEO Success in Al Barsha"
        description="Our optimized stores deliver results."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Traffic Growth",
            description: "50% more organic visitors.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Uplift",
            description: "35% increase in revenue.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "94% positive feedback.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Rank?</Subheading>}
        heading="SEO-friendly E-commerce Websites in Al Barsha"
        description={
          <Description>
            MilaajBrandset creates SEO-friendly e-commerce websites in Al
            Barsha, driving traffic and sales through search engine
            optimization. Contact us to elevate your store today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607083206968-13611e3d76db?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
